import { render, staticRenderFns } from "./SdAllocationPanel.vue?vue&type=template&id=4d3e516b&scoped=true"
import script from "./SdAllocationPanel.vue?vue&type=script&lang=js"
export * from "./SdAllocationPanel.vue?vue&type=script&lang=js"
import style0 from "./SdAllocationPanel.vue?vue&type=style&index=0&id=4d3e516b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d3e516b",
  null
  
)

export default component.exports